import type { Content, Editor } from "@tiptap/core"
import { NodeSelection } from "@tiptap/pm/state"

/**
 * Inserts block content (image, diagram, etc.) and moves the caret into a
 * paragraph after it. Without this, TipTap keeps a NodeSelection on the
 * inserted block and the next insert replaces it.
 */
export function insertBlockContentAndPlaceCaretAfter(
  editor: Editor,
  content: Content
) {
  editor
    .chain()
    .focus()
    .insertContent(content)
    .command(({ chain, state }) => {
      const { selection } = state

      if (!(selection instanceof NodeSelection) || !selection.node.isBlock) {
        return true
      }

      const afterPos = selection.to
      const $after = state.doc.resolve(afterPos)

      if ($after.nodeAfter?.isTextblock) {
        return chain().setTextSelection(afterPos + 1).run()
      }

      return chain()
        .insertContentAt(afterPos, { type: "paragraph" })
        .setTextSelection(afterPos + 1)
        .run()
    })
    .run()
}
